import { Box, IconButton, Dialog, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { formatTimestamp } from './FunctionHelper';

export default function CommonModal({
  open,
  handCloseModal,
  title,
  children,
  closebtn,
  fullScreen = false,
  blur = true,
  upgradeWarning = false,
  isWarn = false,
  isNewAddScan = false,
  isMonitoring = false,
  isBuySearchCredit = false,
  isUploadPdfIcon = false,
  isMassFilter = false,
  isAgencyModal = false,
  isInfoModal = false,
  isFreeDowngrade = false,
  isDownGradeOfferModal = false,
  isSmallWidth = false,
  isDynamicWidth = null,
  isBackLinkUnlock = false,
  isKeywordUnlock = false,
  isLocalSeoUnlock = false,
  lowBlur = null,
  disableBackdropClick = false,
  isAlertModal = false,
  disableScrollLock = false
}) {
  let websiteMonitoringDetails =
    useSelector(
      (state: RootState) => state?.siteAudit?.websiteMonitoringDetails
    ) ?? null;
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  const isUnlock = isKeywordUnlock || isBackLinkUnlock || isLocalSeoUnlock;
  return (
    <Dialog
      disableScrollLock={disableScrollLock}
      fullScreen={fullScreen ?? false}
      maxWidth={isWarn ? 'xs' : 'sm'}
      open={open ?? false}
      onClose={(event, reason) => {
        if (!disableBackdropClick || reason !== 'backdropClick') {
          handCloseModal();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        borderRadius: '0px !important',
        backgroundColor: blur
          ? 'rgba(169, 169, 169, 0.5)'
          : lowBlur
          ? 'rgba(169, 169, 169, 0.3)'
          : 'rgba(169, 169, 169, 0)',
        backdropFilter: blur
          ? 'blur(8px)'
          : lowBlur
          ? 'blur(4px)'
          : 'blur(0px)',
        '& .MuiDialog-paper': {
          maxWidth: isDynamicWidth
            ? isDynamicWidth
            : isSmallWidth
            ? '400px'
            : isBuySearchCredit
            ? 'none'
            : isDownGradeOfferModal
            ? '635px'
            : isFreeDowngrade
            ? '570px'
            : isInfoModal && !isFreeDowngrade
            ? '895px'
            : isUnlock && isAgencyModal
            ? '590px'
            : isNewAddScan || isAgencyModal
            ? '782px'
            : !fullScreen
            ? '600px'
            : 'none',
          minWidth: isNewAddScan ? '750px' : 'none',
          width: isAgencyModal ? '100%' : 'auto',
          backgroundColor: isAlertModal ? 'transparent' : undefined,
          boxShadow: isAlertModal ? 'none' : undefined,
          backgroundImage: isAlertModal ? 'none' : undefined
        }
      }}
    >
      {!isAlertModal && (
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            borderRadius: '8px',
            paddingBottom: '6px',
            textAlign: 'center', // Center the text
            position: 'relative',
            display: isAgencyModal ? 'none' : 'block'
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="relative"
          >
            <Box
              sx={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: '800 !important',
                fontSize: 'var(--font-size-18)',
                lineHeight: '29px',
                paddingLeft: upgradeWarning ? '9px' : '0px',
                marginLeft: isUploadPdfIcon ? 'auto' : 'none',
                marginRight: isUploadPdfIcon ? 'auto' : 'none'
              }}
            >
              {title}
              {isMonitoring &&
                websiteMonitoringDetails?.monitoring &&
                websiteMonitoringDetails?.monitoring_time && (
                  <span
                    style={{
                      marginLeft: '0.5rem',
                      fontSize: '12px',
                      color: 'var(--color-text-purple)'
                    }}
                  >
                    {'Next monitoring date:'}{' '}
                    {formatTimestamp(
                      websiteMonitoringDetails?.monitoring_time,
                      userDetails?.date_format || 'DD/MM/YYYY'
                    ) || ' '}
                  </span>
                )}
            </Box>

            {closebtn && (
              <IconButton
                aria-label="close"
                className="hover:rounded-lg"
                sx={{
                  height: '40px',
                  padding: '8px',
                  paddingRight: upgradeWarning ? '5px' : '8px'
                }}
                onClick={handCloseModal}
              >
                <CloseIcon />
              </IconButton>
            )}
          </Box>
        </DialogTitle>
      )}

      <div
        style={{
          paddingLeft:
            isBuySearchCredit || isAgencyModal || isAlertModal ? '0px' : '24px',
          paddingRight:
            isBuySearchCredit || isAgencyModal || isAlertModal ? '0px' : '24px'
        }}
      >
        {children}
      </div>
    </Dialog>
  );
}
